// root state object.
// each Vuex instance is just a single state tree.
const state = {
    zoomMontageArea: 10,
    montageVideosTitle: '',
    montageVideosDuration: 0,
    montageVideosList: [],
    montageVideosId: 0,
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    /**
     * Zoom in the montage area
     *
     * @function   incrementZoomMontageArea
     * @param      {Object} state
     */
    incrementZoomMontageArea (state) {
        if (state.zoomMontageArea < 15) {
            state.zoomMontageArea++;
        }
    },
    /**
     * Zoom out the montage area
     *
     * @function   decrementZoomMontageArea
     * @param      {Object} state
     */
    decrementZoomMontageArea (state) {
        if (state.zoomMontageArea > 3) {
            state.zoomMontageArea--;
        }
    },
    /**
     * Set the title of the final video after montage
     *
     * @function   setTitleVideoMontageList
     *
     * @param      {Object} state
     * @param      {string} title
     */
    setTitleVideoMontageList (state, title) {
        state.montageVideosTitle = title;
    },
    /**
     * Add video to the montageVideosList
     *
     * @function   addVideoToMontageList
     *
     * @param      {Object} state
     * @param      {Object} video
     */
    addVideoToMontageList (state, video) {
        state.montageVideosId++;
        video.idVideo = state.montageVideosId;
        video.montageSelected = false;
        state.montageVideosList.push(video);
    },
    /**
     * Select / unselect video in the montage area
     *
     * @function   toogleMontageSelected
     *
     * @param      {Object} state
     * @param      {Object} video
     */
    toogleMontageSelected (state, video) {
        video.montageSelected = video.montageSelected !== undefined ? !video.montageSelected : true;
    },
    /**
     * Change the content of the montageVideosList
     *
     * @function   toogleMontageSelected
     *
     * @param      {Object} state
     * @param      {array} videosList
     */
    updateVideoToMontageList (state, videosList) {
        state.montageVideosList = videosList;
    },
    /**
     * Delete the selected videos in the montage area
     *
     * @function   deleteSelectedVideosFromMontageList
     *
     * @param      {Object} state
     */
    deleteSelectedVideosFromMontageList (state) {
        state.montageVideosList = state.montageVideosList.filter(function (el) {
            return el.montageSelected !== true;
        });
    },
    /**
     * Delete the videos in the montage area
     *
     * @function   clearVideoMontageList
     *
     * @param      {Object} state
     */
    clearVideoMontageList (state) {
        state.montageVideosList = [];
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
    incrementZoomMontageArea: ({ commit }) => commit('incrementZoomMontageArea'),
    decrementZoomMontageArea: ({ commit }) => commit('decrementZoomMontageArea'),
    setTitleVideoMontageList: ({ state, commit }, title) => commit('setTitleVideoMontageList', title),
    addVideoToMontageList: ({ state, commit }, video) => commit('addVideoToMontageList', video),
    toogleMontageSelected: ({ state, commit }, video) => commit('toogleMontageSelected', video),
    updateVideoToMontageList: ({ state, commit }, videosList) => commit('updateVideoToMontageList', videosList),
    deleteSelectedVideosFromMontageList: ({ commit }) => commit('deleteSelectedVideosFromMontageList'),
    clearVideoMontageList: ({ commit }) => commit('clearVideoMontageList'),
    canIncrementZoom: ({ commit }) => commit('canIncrementZoom'),
    canDecrementZoom: ({ commit }) => commit('canDecrementZoom'),
};

// getters are functions
const getters = {
    /**
     * Get zoomMontageArea
     */
    getZoomMontageArea:  state => state.zoomMontageArea,
    /**
     * Get montageVideosList
     */
    getMontageVideosList:  state => state.montageVideosList,
    /**
     * Get montageDuration
     */
    getMontageDuration: state => {
        let totalDuration = 0;
        state.montageVideosList.forEach(function(element) {
            totalDuration += durationToSeconds(element.montageDuration);
        });
        return totalDuration;
    },
    canIncrementZoom (state) {
        return state.zoomMontageArea < 15;
    }
    ,
    canDecrementZoom (state) {
        return state.zoomMontageArea > 3;
    }
};

function durationToSeconds (duration) {
    let res = duration.split(":");
    if (res.length === 3) {
        return parseInt(res[2]) + (parseInt(res[1]) * 60) + (parseInt(res[0]) * 3600);
    } else if (res.length === 2) {
        return parseInt(res[1]) + (parseInt(res[0]) * 60);
    }
    return 0;
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./demo/store/modules/montage-videos.js